// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../../../typings.d.ts" />

import { Directive, ElementRef, OnDestroy } from '@angular/core';
import * as textMask from 'vanilla-text-mask';

// Reason we are using this, and source: https://github.com/angular/angular/issues/16755#issuecomment-365045055
@Directive({
  selector: '[datePickerMask]',
  standalone: false,
})
export class DatePickerMaskDirective implements OnDestroy {
  mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // dd/mm/yyyy
  maskedInputController;

  constructor(private element: ElementRef) {
    this.maskedInputController = textMask.maskInput({
      inputElement: this.element.nativeElement,
      mask: this.mask,
    });
  }

  ngOnDestroy() {
    this.maskedInputController.destroy();
  }
}
